import { render, staticRenderFns } from "./FormRadioButtons.vue?vue&type=template&id=3279ae59&scoped=true&"
import script from "./FormRadioButtons.vue?vue&type=script&lang=js&"
export * from "./FormRadioButtons.vue?vue&type=script&lang=js&"
import style0 from "./FormRadioButtons.vue?vue&type=style&index=0&id=3279ae59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3279ae59",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormRadio, BFormRadioGroup} from 'bootstrap-vue'
    installComponents(component, {BFormRadio, BFormRadioGroup})
    

export default component.exports